export const DEPARTMENT = '/department/'
export const DEPARTMENT_ALL = `${DEPARTMENT}all`
export const DEPARTMENT_LABELS = `${DEPARTMENT}label`
